import script from "./MagazineCurrent.vue?vue&type=script&setup=true&lang=js"
export * from "./MagazineCurrent.vue?vue&type=script&setup=true&lang=js"

import "./MagazineCurrent.vue?vue&type=style&index=0&id=748d3c2d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748d3c2d"]])

export default __exports__